"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.default = theme => {
    const hoverColor = ({ variant, color }) => {
        if (variant === 'outline')
            return theme.white1;
        return theme[color] || theme.indigo3;
    };
    const hoverBackgroundColor = ({ variant, color }) => {
        if (variant !== 'outline')
            return 'none';
        return theme[color] || theme.indigo3;
    };
    const boxShadow = ({ variant }) => {
        const shadow = variant === 'float' ? '10px 1px' : '0 0';
        return `0 0 ${shadow} ${theme.indigoPastel2}`;
    };
    return {
        root: {
            position: 'relative',
            color: ({ color }) => theme[color] || theme.indigo3,
            appearance: 'none',
            borderWidth: ({ variant }) => Number(variant === 'outline'),
            borderStyle: 'solid',
            borderColor: 'currentColor',
            borderRadius: '50%',
            width: ({ size }) => size,
            height: ({ size }) => size,
            boxSizing: 'border-box',
            cursor: 'default',
            outline: 'none',
            display: 'block',
            boxShadow,
            transition: `box-shadow 150ms linear`,
            '&::before': {
                content: '""',
                position: 'absolute',
                width: constants_1.MIN_TARGET_SIZE,
                height: constants_1.MIN_TARGET_SIZE,
                top: '50%',
                left: '50%',
                transform: 'translateY(-50%) translateX(-50%)'
            },
            '&[disabled]': {
                opacity: 0.3
            },
            '&:focus': {
                boxShadow: `0 0 0 ${constants_1.FOCUS_OUTLINE_WIDTH}px ${theme.indigoPastel2}`
            },
            '&:not([disabled]):hover': {
                cursor: 'pointer',
                color: hoverColor,
                backgroundColor: hoverBackgroundColor,
                borderColor: hoverBackgroundColor
            },
            '& > svg': {
                display: 'block',
                width: '100%',
                height: '100%',
                stroke: 'currentColor'
            }
        }
    };
};
//# sourceMappingURL=generic.style.js.map